import * as types from './types'
import storage from '@/plugins/storage'
import globals from '@/plugins/globals'
import moment from 'moment'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.DASHBOARD_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.DASHBOARD_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.DASHBOARD_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.DASHBOARD_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.DASHBOARD_FILTER_BY, filterBy)
  },
  [types.SET_ALL_FIRMS](state, all) {
    if (all) {
      state.firms = null
      storage.local.setItem(types.DASHBOARD_FIRMS, null)
    }
    state.allFirms = all
    storage.local.setItem(types.DASHBOARD_ALLFIRMS, state.allFirms)
  },
  [types.SET_FIRMS](state, data) {
    state.firms = data
    storage.local.setItem(types.DASHBOARD_FIRMS, JSON.stringify(data))
  },
  [types.SET_DATE](state, data) {
    console.log('Setting Date', data)
    if (data.name === 'start') {
      state.startDate = moment(data.value).format('YYYY-MM-DD')
    } else {
      state.endDate = moment(data.value).format('YYYY-MM-DD')
    }
  },
  [types.SET_VIEW](state, data) {
    let range = {
      firm: null,
      start: null,
      end: null
    }
    switch (data.name) {
      case 'analyze':
        state.analyzeView = parseInt(data.value)
        break
      case 'range':
        state.rangeView = parseInt(data.value)
        switch (state.rangeView) {
          case 1: // yesterday
            range = globals.pastDayRange()
            break
          case 2: // this Week
            range = globals.weekRange()
            break
          case 3: // this Month
            range = globals.monthRange()
            break
          case 4: // this Quarter
            range = globals.qtrRange()
            break
          case 5: // past 6 Months
            range = globals.past6months()
            break
          case 6: // past Year
            range = globals.pastYear()
            break
          default:
            break
        }
        state.startDate = range.start
        state.endDate = range.end
        break
      case 'firm':
        state.invoiceFirm = parseInt(data.value)
        break
      default:
        break
    }
  },
  [types.RESET_DASHBOARD](state) {
    state.dashboard = null
  },
  [types.RESET_EVALUATION](state) {
    state.evaluation = null
  },
  [types.SET_DASHBOARD](state, data) {
    state.dashboard = data
    console.log('Got Dashboard', state.dashboard)
  },
  [types.SET_DASHBOARDTOP](state, data) {
    state.dashboardTop = data
  },
  [types.SET_ADASRECORDS](state, data) {
    state.adasRecords = []
    if (data) {
      if (data.items) {
        data.items.forEach((element) => {
          if (element.inspections) {
            element.inspections = JSON.parse(element.inspections)
            // element.inspections.forEach((inspection) => {
            //   if (inspection.calibrations) {
            //     inspection.calibrations = inspection.calibrations
            //   }
            // })
          }
        })
      }
      state.adasRecords = data
    }
  },
  [types.SET_COUNTS](state, data) {
    state.counts = data
  },
  [types.SET_TOPSTATS](state, data) {
    state.topStats = data
  },
  [types.SET_EVALUATION](state, data) {
    state.evaluation = data
  },
  [types.SET_FAILEDVINS](state, data) {
    state.failedVins = data
  },
  [types.SET_CLIENTREVIEW](state, data) {
    state.clientReview = data
  },
  [types.SET_CLIENTINSPECTIONS](state, data) {
    state.clientInspections = data
  },
  [types.SET_DECODESTATS](state, data) {
    state.decodeStats = data
  },
  [types.SET_CLIENTBREAKDOWN](state, data) {
    state.clientBreakdown = data
  },
  [types.SET_BMS](state, data) {
    state.bms = null
    if (data) {
      state.bms = data
    }
  },
  [types.RESET_LOG](state) {
    state.log = []
  },
  [types.SET_PARAMETER](state, data) {
    switch (data.name) {
      case 'analyze':
        state.analyzeView = parseInt(data.value)
        break
      case 'firm':
        state.invoiceFirm = parseInt(data.value)
        break
      default:
        break
    }
  },
  [types.FILTER_LOG](state, data) {
    switch (data.action) {
      case 'filter':
        if (data.value !== '') {
          state.log = state.original.filter((x) => x.level.toUpperCase() === data.value.toUpperCase())
        } else {
          state.log = JSON.parse(JSON.stringify(state.original))
        }
        break
      case 'search':
        if (data.value !== '') {
          state.log = state.original.filter((x) => x.message.indexOf(data.value) >= 0 || x.machineName.indexOf(data.value) >= 0)
        } else {
          state.log = JSON.parse(JSON.stringify(state.original))
        }
        break
      case 'sort':
        if (data.value.search !== '') {
          state.log = state.original.filter((x) => x.message.indexOf(data.value.search) >= 0 || x.machineName.indexOf(data.value.search) >= 0)
        } else if (data.value.filter !== '') {
          state.log = state.original.filter((x) => x.level.toUpperCase() === data.value.filter.toUpperCase())
        } else {
          state.log = JSON.parse(JSON.stringify(state.original))
        }
        break
      default:
        break
    }
    if (data.action === 'sort') {
      let sortBy = 'datetime'
      let sortDir = 'asc'
      if (data.value.column.field !== '') {
        sortBy = data.value.column.field
      }
      if (data.value.sortDir !== '') {
        sortDir = data.value.sortDir
      }
      state.log = globals.sortArray(state.log, sortBy, sortDir)
    }
    console.log('Filtering', {
      data: data,
      original: state.original,
      log: state.log
    })
  },
  [types.SET_EMAIL_LOG](state, data) {
    state.log = []
    state.original = []
    if (data) {
      state.log = data
    }
  },
  [types.SET_INTERNAL_LOG](state, data) {
    state.log = []
    state.original = []
    if (data) {
      if (data.length > 0) {
        state.log = data
      }
    }
    console.log('Got the Internal Log', state.log)
  },
  [types.SET_LOG](state, data) {
    state.log = []
    state.original = []
    let temp = []
    if (data) {
      if (data.length > 0) {
        data.forEach((element) => {
          if (element.values) {
            if (element.values.indexOf(';') > 0) {
              let record = element.values.split(';')
              let title = record[3].replace('Message=', '')
              title = title.substring(0, title.indexOf(':'))
              if (record.length > 8) {
                temp.push({
                  timestamp: record[0].replace('LogTimeStamp=', ''),
                  level: record[1].replace('Level=', ''),
                  name: record[2].replace('LoggerName=', ''),
                  message: record[3].replace('Message=', ''),
                  title: title,
                  exception: record[4].replace('Exception=', ''),
                  innerException: record[5].replace('InnerException=', ''),
                  messageLayout: record[6].replace('MessageWithLayout=', ''),
                  machineName: record[7].replace('MachineName=', ''),
                  datetime: new Date(element.timestamp)
                })
              } else if (record.length > 7) {
                temp.push({
                  timestamp: record[0].replace('LogTimeStamp=', ''),
                  level: record[1].replace('Level=', ''),
                  name: record[2].replace('LoggerName=', ''),
                  message: record[3].replace('Message=', ''),
                  title: title,
                  exception: record[4].replace('Exception=', ''),
                  innerException: '',
                  messageLayout: record[5].replace('MessageWithLayout=', ''),
                  machineName: record[6].replace('MachineName=', ''),
                  datetime: new Date(element.timestamp)
                })
              } else {
                temp.push({
                  timestamp: record[0].replace('LogTimeStamp=', ''),
                  level: record[1].replace('Level=', ''),
                  name: record[2].replace('LoggerName=', ''),
                  message: record[3].replace('Message=', ''),
                  title: title,
                  exception: '',
                  innerException: '',
                  messageLayout: record[4].replace('MessageWithLayout=', ''),
                  machineName: record[5].replace('MachineName=', ''),
                  datetime: new Date(element.timestamp)
                })
              }
            }
          }
        })
        if (temp.length > 0) {
          state.log = globals.sortArray(temp, 'datetime')
          state.original = JSON.parse(JSON.stringify(state.log))
        }
      }
    }
    console.log('Got the Log', state.log)
  },
  [types.SET_FRAGMENTATION](state, data) {
    state.fragmentation = data
  },
  [types.SET_MISSING_INDEXES](state, data) {
    state.missingIndexes = data
  },
  [types.SET_AI_LOADING](state, data) {
    state.aiLoading = data
  },
  [types.SET_AI_PROMPT](state, data) {
    state.aiResponse = data
  },
  [types.RESET_QUOTE](state) {
    state.quote = []
  },
  [types.SET_QUOTE](state, data) {
    state.quote = data
    console.log('Got Quote', state.quote)
  },
  [types.RESET_PREDICTIVE](state) {
    state.predictive = []
  },
  [types.SET_PREDICTIVE](state, data) {
    state.predictive = data
    console.log('Got Predictive', state.predictive)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/mutations.js